$(document).ready(function() {
	
	fillCountries();
		
	$("#cancelGuarantee").mask("9999999");
	
	$("#form01, #form02").letterCase($.cookie('siteLocale')).validate({
		meta : "validate",
		focusInvalid: false,
	    invalidHandler: function(form, validator) {
	        if (!validator.numberOfInvalids())
	            return;
	        $('html, body').animate({
	            scrollTop: $(validator.errorList[0].element).offset().top
	        }, 500);
	    }
	});
	
	// Dialog			
	var insurance_desc_overlay = (function() {
		var overlay = null;
		return {
			show : function() {
				if (overlay == null) {
					overlay = $("#insuranceDescriptionsModal").dialog({
						modal : true,
						autoOpen : false,
						resizable : false,
						draggable : false,
						show: "fade",
						hide: "fade",
						width: 720,
						height: 900
					});
				}
				overlay.dialog("open");
			},
			hide : function() {
				if (overlay != null) {
					overlay.dialog("close");
				}
			}
		};
	})();
	$('.insuranceDescriptions').click(function(){		
		$("#insuranceDescriptionsModal").show();
		insurance_desc_overlay.show();
	});

	$("input[type=radio][name=selectInsurance]").on('change', function() {
		var selectedValue = $('input[type=radio][name=selectInsurance]:checked').val();
		$(".insuranceType").hide();
		if(selectedValue == 'Travel'){
			$(".insurance_Travel").show();
		}else if(selectedValue == 'Cancel'){
			$(".insurance_Cancel").show();
		}
	});
	
	
	var datePickerDateFormat = "dd.mm.yy";
	var now = new Date();
	var aYearLater = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
	$("#travelStartDate").datepicker({ 
		dateFormat : datePickerDateFormat,
		numberOfMonths : 1,
		minDate : new Date(),
		maxDate : aYearLater,
		onSelect : function(dateText, inst) {
			var minDate = $.datepicker.parseDate(datePickerDateFormat, dateText);
			var endDateStr = $("#travelEndDate").val();
			var endDate = null;
			if (endDateStr != "")
				endDate = $.datepicker.parseDate(datePickerDateFormat, endDateStr);
			minDate.setDate(minDate.getDate()+1);
			$("#travelEndDate").datepicker("option", "minDate", minDate);
			if (endDateStr == "" || minDate.getTime() >= endDate.getTime()) {
				var newEndDate = new Date(minDate);
				newEndDate.setDate(newEndDate.getDate() + 6);
				$("#travelEndDate").datepicker("setDate", newEndDate);
			}
		},
		onClose : function(dateText, inst) {
   			setTimeout(function() {
                var context = inst.input.parent().parent();
				$('#travelEndDate',context).blur();
				$("#travelEndDate",context).datepicker("show");
               }, 100);
		}
	});
	var minDate = null;
	var minDateStr = $("#travelStartDate").val();
	minDateStr == "" ? minDate = new Date() : minDate = $.datepicker.parseDate(datePickerDateFormat, minDateStr);
	minDate.setDate(minDate.getDate()+1);
	var maxDate = new Date();
	maxDate.setFullYear(minDate.getFullYear() + 1);
	$("#travelEndDate").datepicker({
		dateFormat : datePickerDateFormat,
		numberOfMonths : 1,
		minDate : minDate,
		maxDate : maxDate,
		onClose : function(dateText, inst) {
		}
	});
	
	var miliSecInDay = 1000*60*60*24;
	$("#searchButton").click(function() {
		var isvalid = $("#form01").valid();
		if (!isvalid)
			return false;
		
		if('Travel' == $("#selectInsurance option:selected").val()){
			var startDate = $.datepicker.parseDate(datePickerDateFormat, $("#travelStartDate").val());
			var endDate = $.datepicker.parseDate(datePickerDateFormat, $("#travelEndDate").val());
            var rangeDay = (endDate.getTime()-startDate.getTime())/miliSecInDay;
			if(rangeDay < 1){
				return false;
			}else if(rangeDay > 31){
				alert(FmtMessage.getMessage('js.insurance.travel.date.range.limit'));
				return false;
			}
		}
		
		openLoaderBox();
		
		$.ajax({
			url : '/insurance/search',
			dataType : "json",
			type : 'POST',
			data : $("#form01").serialize(),
			success : function(data) {
				$("#reservation_info").show();
				$("[name=searchGuid]").val(data.searchGuid);
				$("#searchPrice").html(data.amount +' '+ data.currency);
				$('#search_info [name]').attr('readonly', 'readonly').attr("disabled", true);
				$("#searchChangeButton").show();
				$("#reservation_info").show();
				$("#searchButton").hide();
				$("#addPassenger").hide();
				$("#delPassenger").hide();
				closeLoaderBox();
				$('html, body').animate({
				    scrollTop: $("#form02").offset().top - document.body.clientHeight + $("#form02").height()
				}, 1000);
			},
			error : function(xhr, ajaxOptions, errorThrown) {
				closeLoaderBox();
			}
		});
	});
	
	$("#searchChangeButton").click(function() {
		$('#search_info [name]').removeAttr('readonly').removeAttr("disabled");
		$("#searchChangeButton").hide();
		$("#reservation_info").hide();
		$("#searchButton").show();
		$("#addPassenger").show();
		$("#delPassenger").hide();
	});
	
	$("#searchChangeButton").hide();
	
	
	$("#makeTicketFinal").click(function() {
		
		var isvalid = $("#form02").valid() && emailValidation();
		if (!isvalid)
			return false;
		
		if(!checkAgreementStatus()){
			alert(FmtMessage.getMessage('js.payment.agreement.warning'));
			return false;
		}
		
		openLoaderBox();
		$("#cc-error").hide();
		$("#alert-success").hide();

		$.ajax({
			url : '/insurance/create/policy',
			dataType : "json",
			type : 'POST',
			data : $("#form02").serialize(),
			success : function(data) {
				if(data.hasError){
					$("#error_message").html(data.errorMessage);
					$("#cc-error").show();
					$('html, body').animate({
				        scrollTop: $('#cc-error').offset().top
				    }, 500);
				}else{
					$("#successMessage").html(data.successMessage);
					 var passContent = '<tr><th><fmt:message key="insurance.passenger" /></th><th><fmt:message key="insurance.policy.status" /></th></tr>';
					 for(var i=0; i < data.people.length;i++) {
					    var person = data.people[i];
					    passContent = passContent + '<tr>';
					    passContent = passContent + '<td>'+person.name+' '+person.surname+'</td>';
					    passContent = passContent + '<td>'+person.statsuMessage+'</td>';
					    passContent = passContent + '<tr>';
					 }
					$("#successPass").html(passContent);
					$("#alert-success").show();
// 						$('html, body').animate({
// 					        scrollTop: $('#successMessage').offset().top
// 					    }, 500);
					
					$('#insuranceSuccessForm').find('#orderId').val(data.orderId);
					$('#insuranceSuccessForm').submit();
					
				}
				closeLoaderBox();
			},
			error : function(xhr, ajaxOptions, errorThrown) {
				$("#error_message").html(ajaxOptions);
				$(".cc-error").show();
				$('html, body').animate({
			        scrollTop: $('#cc-error').offset().top
			    }, 500);
				closeLoaderBox();
			}
		});
	});
	
	
	$("#addPassenger").click(function() {
		var passCount = $('[name=numADT]').val();
		var  maxCount = $(this).attr('maxCount');
		$("#passenger_"+passCount).show();
		if(Number(passCount) < maxCount)
			$('[name=numADT]').val(Number(passCount)+1);
	});
	
	$("#delPassenger").click(function() {
		var passCount = $('[name=numADT]').val();
		var index = Number(passCount)-1;
		if(index > 0){
			$("#passenger_"+index).hide();
			$('[name=numADT]').val(index);
		}
	});
	
	$("#travelCountry").msDropdown();
	$("#travelCountry").parent().css("overflow","").css("width","205px");
	$("#contactCountry").msDropdown();
	
	$("#travelCountry").change(function() {
		if($("#travelCountry option:selected"))
			$("#travelCountry-error").remove();
		else return;
	});
	
});


function clearPassInfos() {
	$('.passengerInfo [name]').val("");;
}